<template>
    <header id="header" :class="{ 'header-escondido': esconderHeader }">
        <div class="conteudo-header">
            <div id="logo-column">
                <div id="logo">
                    <h4 class="texto-logo azul">J.</h4>
                    <h4 class="texto-logo">Line</h4>
                </div>
    
                <p class="detalhe-logo">Limpeza e higienização de sofás</p>
            </div>

            <button id="menu" @click="mostrarMenu=!mostrarMenu">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-menu-2"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 6l16 0" /><path d="M4 12l16 0" /><path d="M4 18l16 0" /></svg>
            </button>
        </div>

        <div id="menu-aberto" v-if="mostrarMenu">
            <a href="#banner" class="sessao-link" @click="mostrarMenu=!mostrarMenu" :class="{ ativo: sessaoAtiva === 'banner' }">Inicio</a>
            <a href="#quem-somos" class="sessao-link" @click="mostrarMenu=!mostrarMenu" :class="{ ativo: sessaoAtiva === 'quem-somos' }">Quem somos</a>
            <a href="#servicos" class="sessao-link" @click="mostrarMenu=!mostrarMenu" :class="{ ativo: sessaoAtiva === 'servicos' }">Serviços</a>
            <a href="#galeria" class="sessao-link" @click="mostrarMenu=!mostrarMenu" :class="{ ativo: sessaoAtiva === 'galeria' }">Galeria</a>
            <a href="#agendar" class="sessao-link" @click="mostrarMenu=!mostrarMenu" :class="{ ativo: sessaoAtiva === 'agendar' }">Agendar</a>
        </div>
    </header>

</template>

<script>
export default{
    name: 'HeaderLandingPage',
    data() {
        return {
            mostrarMenu: false,
            esconderHeader: false,
            ultimaPosicaoScroll: 0,
            sessaoAtiva: 'banner',
            observer: null
        }
    },

    mounted() {
        window.addEventListener('scroll', this.verificarScroll)

        this.observer = new IntersectionObserver(
            (entradas) => {
                entradas.forEach((entrada) => {
                    if (entrada.isIntersecting) {
                        this.sessaoAtiva = entrada.target.id
                    }
                })
            },
            {
                threshold: 0.3
            }
        )

        const secoes = [
            'banner',
            'quem-somos',
            'servicos',
            'galeria',
            'agendar'
        ]

        secoes.forEach((id) => {
            const elemento = document.getElementById(id)
            if (elemento) {
                this.observer.observe(elemento)
            }
        })
    },

    beforeUnmount() {
        window.removeEventListener('scroll', this.verificarScroll)
    },

    methods: {
        verificarScroll() {
            const posicaoAtual = window.scrollY

            if (posicaoAtual <= 10) {
                this.esconderHeader = false
                this.ultimaPosicaoScroll = posicaoAtual
                return
            }

            if (posicaoAtual > this.ultimaPosicaoScroll) {
                this.esconderHeader = true
                this.mostrarMenu = false
            }

            else {
                this.esconderHeader = false
            }

            this.ultimaPosicaoScroll = posicaoAtual
        }
    }
}
</script>

<style scoped>
#header{
    height: 80px;
    width: 100%;
    background-color: var(--cor-fundo-header);
    position: relative;
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;

    transition: transform 0.3s ease;
}

.header-escondido {
    transform: translateY(-100%);
}

.conteudo-header{
    height: 100%;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;

    box-sizing: border-box;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

#logo-column{
    display: flex;
    flex-direction: column;
    
}

#logo{
    display: flex;
    flex-direction: row;
    align-items: center;
}

.texto-logo{
    font-size: 22px;
    font-weight: 500;
    color: var(--cor-texto-header);
}

.texto-logo.azul{
    color: var(--cor-texto-azul-header);
}

.detalhe-logo{
    font-size: 10px;
    color: var(--cor-texto-pequeno-header); 
}


#menu{
    width: 20px;
    height: 20xp;
    border: none;
    background: none;
    cursor: pointer;
    transition: all ease 0.5s;
    color: var(--cor-tema);
}

#menu:hover{
    opacity: 0.7;
}

#menu-aberto{
    width: 200px;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: var(--cor-fundo-header);
    border-radius: 5px;
    position: absolute;
    top: 90px;
    right: 10px;
    padding: 32px 16px;
    box-sizing: border-box;
    filter: drop-shadow(0 0 12px #0d0d0d0d);
}

.sessao-link{
    color: var(--cor-texto-header);
    font-size: 14px;
    font-weight: 450;
    text-decoration: none;
    transition: all ease 0.4s;
}

.sessao-link.ativo{
    color: var(--cor-tema);
    font-weight: 500;
}

.sessao-link:hover{
    opacity: 0.7;
}

@media (min-width: 768px) and (max-width: 1200px){
    #header{
        padding: 0 30px;
        box-sizing: border-box;
    }

    #menu-aberto{
        gap: 24px;
    }
}

@media (max-width: 600px) {
    #header{
        padding: 0 30px;
        box-sizing: border-box;
    }

    #menu-aberto{
        gap: 24px;
    }
}
</style>